import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { showModal } from '@store/actions/commonAction';
import { saveDeviceInfo, authByCp } from '@store/actions/userAction';

import SatInput from '@components/common/satUI/SatInput';
import SatButton from '@components/common/satUI/SatButton';

import { isMobile, getDeviceInfo } from '@common/utils/device';
import footerLogo from '@assets/images/img/img-splash-prudential-logo@2x.png';

const AuthTrustDevice = () => {
  const nameRef = useRef();
  const birthRef = useRef();
  const cpNoRef = useRef();
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState({
    username: '',
    birthDate: '',
    cpNo: '',
  });

  useEffect(() => {
    if (isMobile.any()) {
      window.addEventListener('getDeviceInfoCallBack', getDeviceInfoCallBack);
      getDeviceInfo();
    } else {
      // TODO pc버전 deviceId/deviceName 어떻게 할지
      dispatch(
        saveDeviceInfo({
          deviceId: 'Chrome',
          deviceName: 'WEB',
          appVersion: '0.0.1',
        }),
      );
    }
  }, []);

  const getDeviceInfoCallBack = ({
    data: { deviceId, deviceName, appVersion },
  }) => {
    dispatch(saveDeviceInfo({ deviceId, deviceName, appVersion }));
  };

  const handleInputEvent = (value, targetId) => {
    setUserInfo({ ...userInfo, [targetId]: value });
  };

  const handleAuthByCp = () => {
    const validation = () => {
      const { username, birthDate, cpNo } = userInfo;
      if (username === '' || birthDate === '' || cpNo === '') {
        dispatch(
          showModal({
            visible: true,
            type: 'info',
            msg: '입력 정보가 없는 항목이 있습니다.\n입력 정보를 다시 확인해주세요.',
          }),
        );
        return false;
      } else if (
        !(
          nameRef.current.getValidStatus() &&
          birthRef.current.getValidStatus() &&
          cpNoRef.current.getValidStatus()
        )
      ) {
        return false;
      }

      return true;
    };

    if (validation()) {
      dispatch(authByCp(userInfo));
    } else {
      console.log('### valid false');
    }
  };

  return (
    <div className="login-area">
      <h2 className="tit">
        {localStorage.getItem('loginHistory') ? (
          <>
            간편 비밀번호 재설정을 위해
            <br />
            <strong>본인 인증</strong>을 진행해주세요.
          </>
        ) : (
          <>
            반갑습니다.
            <br />
            처음 로그인하는 기기에서는
            <br />
            <strong>휴대전화 인증</strong>이 필요합니다.
          </>
        )}
      </h2>
      <div className="login-form">
        <SatInput
          ref={nameRef}
          value={userInfo.username}
          label="이름"
          border
          onChange={value => handleInputEvent(value.trim(), 'username')} // 공백제거 요청
          onPressEnter={() => birthRef.current.onFocus()}
        />
        <SatInput
          ref={birthRef}
          value={userInfo.birthDate}
          type="number"
          label="생년월일 6자리 (예:780508)"
          focusLabel="생년월일 6자리"
          border
          onChange={value => handleInputEvent(value, 'birthDate')}
          maxLength={6}
          validRule={[
            {
              rule: v => v.length === 6,
              errMsg: '생년월일은 6자리로 입력합니다.',
            },
          ]}
          onPressEnter={() => cpNoRef.current.onFocus()}
        />
        <SatInput
          ref={cpNoRef}
          value={userInfo.cpNo}
          type="number"
          label="휴대전화번호"
          maxLength={11}
          border
          useMobile
          onChange={value => handleInputEvent(value, 'cpNo')}
        />
        <div className="text-center">
          <p className="text-info2 ico-type">
            푸르덴셜생명에 등록된 정보를 입력해 주세요.
          </p>
        </div>
        <div className="btn-area">
          <SatButton
            label="인증번호 받기"
            styleClass="btn-l blue"
            onClick={handleAuthByCp}
          />
        </div>
      </div>
      <div className="footer-logo">
        <img src={footerLogo} />
      </div>
    </div>
  );
};

export default AuthTrustDevice;
